//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum DeliveryMethod {
	PorterBuddy = 0,
	PostNHome = 1,
	PostNMail = 2,
	PostNPick = 3,
	SfjStore = 4,
	HeltHjem = 5,
	PostNPickLockers = 6,
	InstaBox = 7,
	InstaBoxHome = 8,
	AirmeeHome = 9,
	HeltHjemServicePoint = 10,
	Gordon = 11
}
